import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export function LegalShell({ title, subtitle, children }) {
  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-12">
      <Link to="/" className="overline inline-flex items-center gap-1.5 hover:text-white mb-6" data-testid="legal-back">
        <ArrowLeft size={14} weight="bold" /> Back
      </Link>
      <div className="overline mb-2">{subtitle}</div>
      <h1 className="font-head text-4xl sm:text-5xl text-white tracking-tight leading-[0.95] mb-4">{title}</h1>
      <p className="text-[#52525b] text-xs mb-10">Last updated: {new Date().toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}</p>
      <div className="prose-legal space-y-6 text-[#A1A1AA] text-sm leading-relaxed">
        {children}
      </div>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="font-head text-xl text-white uppercase tracking-tight mb-3">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
